import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';

// /tracking and /dashboard are separate full-page entries (Basic Auth at ingress); they never boot the debtor app or its tracker.
const path = window.location.pathname;
const root = /^\/tracking(?:\/|$)/.test(path)
  ? import('./app/features/tracking-dashboard/tracking-dashboard.component').then((m) => m.TrackingDashboardComponent)
  : /^\/dashboard\/?$/.test(path)
    ? import('./app/features/project-dashboard/project-dashboard.component').then((m) => m.ProjectDashboardComponent)
    : Promise.resolve(App);

root.then((component) => bootstrapApplication(component, appConfig)).catch((err) => console.error(err));
